import React from "react";

import "../Styles/Register.css";

import { useState } from "react";

import { useNavigate } from "react-router-dom";

import axios from "axios";

export default function Register() {
    const navigate = useNavigate();

    const [imgPath, setImgPath] = useState("https://anatole-sot.xyz/api/recettes-gibli/uploads/users/image0.png");

    function onFormSubmit(event) {
        event.preventDefault();
        const name = document.getElementById("name").value;
        const email = document.getElementById("email").value;
        const password = document.getElementById("password").value;
        const password2 = document.getElementById("password2").value;
        const profilePicture = document.getElementById("profilePicture").files[0];

        let formData = new FormData();


        if (name === "" || email === "" || password === "" || password2 === "") {
            alert("Merci de remplir tous les champs");
            return;
        }
        if (password !== password2 ) {
            alert("Les mots de passe ne correspondent pas");
            return;
        }
        formData.append("username", name);
        formData.append("email", email);
        formData.append("password", password);
        formData.append("file", profilePicture);

        axios.post("https://anatole-sot.xyz/api/recettes-gibli/signup.php", formData, {headers: {"Content-Type": "multipart/form-data"}})
        .then((response) => {
            if (response.data.status === "success") {
                alert("Votre compte a bien été créé");
                navigate("/login");
            } else {
                alert(response.data.data);
            }
        })
    }

    function readURL(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
    
            reader.onload = function (e) {
                setImgPath(e.target.result);
            }
    
            reader.readAsDataURL(input.files[0]);
        }
    }
    
    function onUpload(event){
        readURL(event.target);
    };
    return (
        <main className="Register">
            <form>
                <label htmlFor="name">Nom d'utilisateur</label>
                <input type="text" id="name" name="name" placeholder="Entrez votre nom d'utilisateur" required/>
                <label htmlFor="profilePicture">Image de profil</label><br/>
                N'hésitez pas à utiliser <a href="https://picrew.me/en/image_maker/263035" target="_blank" rel="noreferrer">PiCrew</a> pour créer votre image de profil
                <input type="file" id="profilePicture" name="profilePicture" accept="image/*" onChange={onUpload} required/>
                <img id="blah" src={imgPath} alt="Votre profil" />
                <label htmlFor="email">Email</label>
                <input type="email" id="email" name="email" placeholder="Entrez votre email" required/>
                <label htmlFor="password">Mot de Passe</label>
                <input type="password" id="password" name="password" placeholder="Entrez votre mot de passe" required/>
                <label htmlFor="password">Confirmation du Mot de Passe</label>
                <input type="password" id="password2" name="password2" placeholder="Confirmez votre mot de passe" required/>
                <button type="submit" id="submit" onClick={onFormSubmit}>S'inscrire</button>
            </form>
        </main>
    );
}